import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateRange from 'components/Form/DateRange';
import Text from 'components/Form/Text';
import { SubstanceDrugsSupplementalPublicSafetyItemModel } from 'forms/sections/substance/drugs/supplementalPublicSafety/types';
import {
  CommonOnUpdate, CommonScrollIntoView, CommonOnError, CommonRequired
} from 'types/props';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';

interface Props extends Partial<SubstanceDrugsSupplementalPublicSafetyItemModel>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  scrollIntoView?: CommonScrollIntoView
  onError?: CommonOnError
  required?: CommonRequired
  formType?: string

}

export default class DrugSupplementalPublicSafetyUse extends ValidationElement<Props> {
  update = (updateValues: Partial<SubstanceDrugsSupplementalPublicSafetyItemModel>) => {
    if (this.props.onUpdate) {
      this.props.onUpdate({
        DrugUsed: this.props.DrugUsed,
        DateRange: this.props.DateRange,
        NumberOfTimesUsed: this.props.NumberOfTimesUsed,
        Comment: this.props.Comment,
        ...updateValues,
      });
    }
  };

  updateDrugUsed = (values: SubstanceDrugsSupplementalPublicSafetyItemModel['DrugUsed']) => {
    this.update({ DrugUsed: values });
  };

  updateDateRange = (values: SubstanceDrugsSupplementalPublicSafetyItemModel['DateRange']) => {
    this.update({ DateRange: values });
  };

  updateNumberOfTimesUsed = (values: SubstanceDrugsSupplementalPublicSafetyItemModel['NumberOfTimesUsed']) => {
    this.update({ NumberOfTimesUsed: values });
  };

  updateComment = (values: SubstanceDrugsSupplementalPublicSafetyItemModel['Comment']) => {
    this.update({ Comment: values });
  };

  render() {
    const attribute = `List.items[${this.props.$index}].Item`;

    const isPvq = isPVQForm(this.props.formType);
    return isPvq ? (
      <div className="drug-supplemental-public-safety-use">
        <Field
          attribute={`${attribute}.DrugUsed`}
          title={i18n.t('substance.pvq.drugs.supplementalPublicSafety.heading.drugUsed')}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            attribute={`${attribute}.DrugUsed`}
            name="DrugUsed"
            className="drug-used"
            {...this.props.DrugUsed}
            onUpdate={this.updateDrugUsed}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>

        <Field
          attribute={`${attribute}.DateRange`}
          title={i18n.t('substance.pvq.drugs.supplementalPublicSafety.heading.dateRange')}
          adjustFor="daterange"
          help="substance.drugs.supplementalPublicSafety.help.dateRange"
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateRange
            attribute={`${attribute}.DateRange`}
            name="DateRange"
            className="date-range"
            minDateEqualTo
            {...this.props.DateRange}
            onUpdate={this.updateDateRange}
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>

        <Field
          attribute={`${attribute}.NumberOfTimesUsed`}
          title={i18n.t('substance.pvq.drugs.supplementalPublicSafety.heading.numberOfTimesUsed')}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Text
            attribute={`${attribute}.NumberOfTimesUsed`}
            name="NumberOfTimesUsed"
            className="number-of-times-used"
            {...this.props.NumberOfTimesUsed}
            onUpdate={this.updateNumberOfTimesUsed}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>
      </div>

    ) : (
      <div className="drug-supplemental-public-safety-use">
        <Field
          attribute={`${attribute}.DrugUsed`}
          title={i18n.t('substance.drugs.supplementalPublicSafety.heading.drugUsed')}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            attribute={`${attribute}.DrugUsed`}
            name="DrugUsed"
            className="drug-used"
            {...this.props.DrugUsed}
            onUpdate={this.updateDrugUsed}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>

        <Field
          attribute={`${attribute}.DateRange`}
          title={i18n.t('substance.drugs.supplementalPublicSafety.heading.dateRange')}
          adjustFor="daterange"
          help="substance.drugs.supplementalPublicSafety.help.dateRange"
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateRange
            attribute={`${attribute}.DateRange`}
            name="DateRange"
            className="date-range"
            minDateEqualTo
            {...this.props.DateRange}
            onUpdate={this.updateDateRange}
            onError={this.props.onError}
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>

        <Field
          attribute={`${attribute}.NumberOfTimesUsed`}
          title={i18n.t('substance.drugs.supplementalPublicSafety.heading.numberOfTimesUsed')}
          scrollIntoView={this.props.scrollIntoView}
        >
          <Text
            attribute={`${attribute}.NumberOfTimesUsed`}
            name="NumberOfTimesUsed"
            className="number-of-times-used"
            {...this.props.NumberOfTimesUsed}
            onUpdate={this.updateNumberOfTimesUsed}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>
        <Comments
          title={i18n.t('substance.drugs.supplementalPublicSafety.heading.comment')}
          name="Comment"
          className="supplemental-public-safety-comment"
          attribute={`${attribute}.Comment`}
          {...this.props.Comment}
          onUpdate={this.updateComment}
          required={false}
        />
      </div>
    );
  }
}

DrugSupplementalPublicSafetyUse.defaultProps = {
  onError: (value, arr) => arr,
  formType: '',
};
